import { CommonModule, registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import localeIt from '@angular/common/locales/it';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { CookieInterceptor } from '@shared/interceptors/cookie.interceptor';
import { SharedModule } from '@shared/shared.module';
import { LoginModule } from '../login/login.module';
import { initializeCoreFactory } from './initializer/core.initializer';
import { CustomExceptionInterceptor } from './interceptors/custom-exception.interceptor';
import { AnalyticsService } from './services/analytics.service';
import { AuctionService } from './services/auction.service';

registerLocaleData(localeIt);

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  const i18nURL: string = '/assets/i18n/';
  return new TranslateHttpLoader(http, i18nURL, '.json');
}

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    LoginModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CookieInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: AuthInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: CustomExceptionInterceptor,
    },
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: ErrorInterceptor,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeCoreFactory,
      deps: [AuctionService, AnalyticsService, Router],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
